import experiencesEn from './experiences.en';
import experiencesAr from './experiences.ar';

export function getExperiences(lang = 'en') {
  return lang === 'ar' ? experiencesAr : experiencesEn;
}
